import { AnswerType } from "@models";

export const ANSWER_TYPE: Record<string, AnswerType> = {
  correct: "correct",
  incorrect: "incorrect",
  unanswered: "unanswered",
};
